import { render, staticRenderFns } from "./ProductCardDetails.vue?vue&type=template&id=2da8daa8&scoped=true&"
import script from "./ProductCardDetails.vue?vue&type=script&lang=ts&"
export * from "./ProductCardDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCardDetails.vue?vue&type=style&index=0&id=2da8daa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da8daa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VIcon,VImg,VLayout,VNavigationDrawer,VSpacer})
